import { SystemConfig } from "../../../hooks/useSystemConfig";
import { SettingsCenter } from "./getSettingsCenterData";
import {
  OfferingVisibility,
  Package,
  PackageOffering,
  PackagesData,
} from "./types";

const normalizePackages = (
  center: SettingsCenter,
  systemConfig: SystemConfig,
): PackagesData => {
  const centerConfig = center.center_configs[0];

  const currencyCode =
    centerConfig?.default_currency_code || systemConfig.default_currency_code;

  const discountAmount =
    centerConfig?.discount_amount ?? systemConfig.discount_amount;

  const packages = center.center_packages.map<Package>((packageItem) => {
    const {
      id,
      name,
      visibility,
      price,
      center_offerings,
      deposit_amount,
      description,
      modality_name,
      marketing_text,
      duration_minutes,
    } = packageItem;

    const offerings = center_offerings
      .map<PackageOffering | null>((offering) => {
        if (!offering.offering_id) throw new Error("Missing offering_id");
        if (offering.visibility === "archived") return null;
        return {
          id: offering.offering_id,
          name: offering.name,
          price: offering.price,
          durationMinutes: offering.duration_minutes || 0,
          visibility: offering.visibility as OfferingVisibility,
          side: offering.scan_side,
        };
      })
      .filter((offering) => offering !== null) as PackageOffering[];

    return {
      id,
      name,
      visibility,
      price,
      offerings,
      depositAmount: deposit_amount,
      description,
      modalityName: modality_name,
      marketingText: marketing_text || "",
      durationMinutes: duration_minutes,
    };
  });

  const offerings = center.center_offerings
    .map<PackagesData["offerings"][number]>((offering) => {
      const {
        name,
        visibility,
        price,
        deposit_amount,
        scan_side,
        center_package_id,
        duration_minutes,
      } = offering;

      const id = offering.offering_id;

      if (!id) throw new Error("Missing offering id");

      return {
        id,
        name,
        visibility,
        price,
        scan_side,
        deposit_amount,
        duration_minutes: duration_minutes || 0,
        center_package_id: center_package_id || undefined,
      };
    })
    .filter((offering) => offering.scan_side === "single");

  return { packages, currencyCode, minPrice: discountAmount, offerings };
};

export default normalizePackages;
